export default "__VITE_ASSET__BNf28zqG__"